import React from 'react';

const FLAGS = [
  { key: 'hasDemo', label: 'Demo' },
  { key: 'hasVideo', label: 'Video' },
  { key: 'has3DView', label: '3D View' },
  { key: 'hasSpecSheet', label: 'Spec Sheet' },
  { key: 'hasCaseStudy', label: 'Case Study' },
  { key: 'hasTestimonials', label: 'Testimonials' },
  { key: 'hasComparisons', label: 'Comparisons' },
];

const FeatureFlagsEditor = ({ formData, setFormData }) => {
  const flags = formData.featureFlags || {};

  const toggleFlag = (key) => {
    setFormData(prev => ({
      ...prev,
      featureFlags: { ...prev.featureFlags, [key]: !prev.featureFlags?.[key] }
    }));
  };

  return (
    <div className="form-group">
      <label>Feature Flags</label>
      <div className="checkbox-group">
        {FLAGS.map(flag => (
          <div key={flag.key} className="checkbox-item">
            <label>
              <input
                type="checkbox"
                checked={flags[flag.key] || false}
                onChange={() => toggleFlag(flag.key)}
              />
              {flag.label}
            </label>
          </div>
        ))}
      </div>
    </div>
  );
};

export default FeatureFlagsEditor;
